import { createSlice } from "@reduxjs/toolkit";
import { tasksId } from "../../../types/activityTasks";
import { activitiesInformation } from "../../../helpers/Activities";
import { menuActiIntroduction } from "../../../helpers/menuImagesIntroduction";

const initialState = {
	loaded: false,
	loadedScene: true,
	activitiesInformation: activitiesInformation(),
	actualSubtemaSelected: tasksId.tema1.activities.subtema1,
	returnHome: false,
	menuIntroduction: menuActiIntroduction(),
	activeModalInstruction: false
};

export const menuSlice = createSlice({
	name: "menu",
	// estado inicial definido en la parte superior line:3
	initialState,
	// todas las acciones que puden modificar el store
	reducers: {
		changeActivity: (state, { payload }) => {
			state.activitiesInformation[payload.subtema].task = payload.activitiesInformationUpdated;
			state.activitiesInformation[payload.subtema].numberOfTaskCompleted = payload.numberOfTaskCompleted;
			localStorage.setItem("saveGame", JSON.stringify(state.activitiesInformation));
		},
		openNextSubtema: (state, { payload }) => {
			state.activitiesInformation[payload.next].isOpen = true;
			state.activitiesInformation[payload.next].task[0].isOpen = true
			state.actualSubtemaSelected = payload.current;
		},
		loadComplete: (state) => {
			state.loaded = true;
		},
		loadCompleteScene: (state) => {
			state.loadedScene = true;
		},
		initLoading: (state) => {
			state.loaded = false;
		},
		initLoadingScene: (state) => {
			state.loadedScene = false;
		},
		changeSubtema: (state, { payload }) => {
			state.actualSubtemaSelected = payload;
		},
		changueReturnHome: (state, { payload }) => {
			state.returnHome = payload;
		},
		setActiveModalInstruction: (state, { payload }) => {
			state.activeModalInstruction = payload;
		},

	},
});

export const { changeActivity, loadComplete, loadCompleteScene, initLoadingScene, initLoading, openNextSubtema, changeSubtema, changueReturnHome, setActiveModalInstruction } = menuSlice.actions;
